import { Component } from "react";
import { observer, inject } from "mobx-react";
import propTypes from "prop-types";

import { ActionsBlock } from "./ActionsBlock.jsx";
import { ActionsBlockMobile } from "./ActionsBlockMobile.jsx";
import "../../less/my-products/my-cart.less";
class _StickyActionsBlock extends Component {
  render() {
    const { headerHeight, isMobile } = this.props.uiStore;
    const headerIndent = headerHeight + (isMobile ? 0 : 20);

    const actionsBlock = isMobile ? <ActionsBlockMobile /> : <ActionsBlock />;

    // TODO: set sticky by CSS. Need get header height.
    return (
      <div
        className="my-cart__controls actions-block"
      >
        {actionsBlock}
      </div>
    );
  }
}

_StickyActionsBlock.propTypes = {
  cartStore: propTypes.shape({
    isEmptyCart: propTypes.bool,
  }).isRequired,
  uiStore: propTypes.shape({
    headerHeight: propTypes.number,
    isMobile: propTypes.bool,
  }).isRequired,
};

export const StickyActionsBlock = inject((allStores) => ({
  cartStore: allStores.cartStore,
  uiStore: allStores.uiStore,
}))(observer(_StickyActionsBlock));
